import { render, staticRenderFns } from "./DepositDetails.vue?vue&type=template&id=55908da9&"
import script from "./DepositDetails.vue?vue&type=script&lang=js&"
export * from "./DepositDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports